// extracted by mini-css-extract-plugin
module.exports = {"alert_card_close":"AlertClose_alert_card_close__jtjG8","bigger_title":"AlertClose_bigger_title__2YfUY"};